import CardGridItemSkeleton from './CardGridItemSkeleton';

function CardGridItemSkeletonGroup() {
  return (
    <>
      <CardGridItemSkeleton />
      <CardGridItemSkeleton />
      <CardGridItemSkeleton />
      <CardGridItemSkeleton />
      <CardGridItemSkeleton />
      <CardGridItemSkeleton />
    </>
  );
}

export default CardGridItemSkeletonGroup;
